import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { CircleBox } from "@features/recommender/common";

interface Props {
  ogFundName: string;
  recommendationName: string;
  margin?: string;
}

export const LegendBlock = ({
  ogFundName,
  recommendationName,
  margin,
}: Props) => {
  const theme = useTheme();
  return (
    <Box display="flex" flexDirection="column" m={margin}>
      <Box display="flex" alignItems="center" gap={2}>
        <CircleBox
          sx={{
            backgroundColor: theme.palette.graphVisual["02"].mid,
          }}
        />
        <Typography variant="body3" color="text.secondary">
          {recommendationName}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={2}>
        <CircleBox
          sx={{
            backgroundColor: theme.palette.graphVisual["06"].mid,
          }}
        />
        <Typography variant="body3" color="text.secondary">
          {ogFundName}
        </Typography>
      </Box>
    </Box>
  );
};
